// extracted by mini-css-extract-plugin
export var button = "styles-module--button--e5d02";
export var disabled = "styles-module--disabled--ea2c1";
export var noPointerEvents = "styles-module--noPointerEvents--897fd";
export var quaternary = "styles-module--quaternary--fdae1";
export var secondary = "styles-module--secondary--11623";
export var tertiary = "styles-module--tertiary--8ec8e";
export var transparent = "styles-module--transparent--cb149";